<template>
  <div class="warp" style="padding: 0 20px; height: calc(100vh - 80px); overflow: auto">
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column :label="$t('operationCenter.bagNumber')" prop="bagNumber" />
      <el-table-column :label="$t('GlobalSetObj.OutflowBranch')" prop="sentOutSiteName" />
      <el-table-column :label="tableLabel" prop="returnStatus">
        <template slot-scope="scope">
          <div v-if="scope.row.returnStatus === 1" style="color: #f1bf44">
            {{ scope.row.returnStatusName }}
          </div>
          <div v-else-if="scope.row.returnStatus === 2" style="color: #24d634">
            {{ scope.row.returnStatusName }}
          </div>
          <div v-else-if="scope.row.returnStatus === 0" style="color: red">
            {{ scope.row.returnStatusName }}
          </div>
          <div v-else>{{ scope.row.returnStatusName }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('GlobalSetObj.OutflowTime')" prop="sentOutTime" />
      <el-table-column :label="$t('GlobalSetObj.InflowBranch')" prop="targetSiteName" />
      <el-table-column :label="$t('GlobalSetObj.InflowTime')" prop="arrivalTime" />
    </el-table>
    <div style="text-align: right">
      <el-pagination
        :current-page.sync="searchForm.pageNumber"
        :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 15px 0"
        @current-change="getSearch"
        @size-change="getSearch"
      />
    </div>
  </div>
</template>

<script>
import { apiGetBagRecycleDetails } from '@/api/newExpressAPI';

export default {
  props: {
    detailInOutObj: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumber: ''
        }
      },
      tableData: [],
      total: 0,
      tableLabel: this.$t('GlobalSetObj.RecyclingStatus')
    };
  },
  created() {
    if (this.detailInOutObj.type === 'in') {
      this.tableLabel = this.$t('home.returnStatus');
    }
    this.getSearch();
  },
  methods: {
    getSearch() {
      const data = {
        pageNumber: this.searchForm.pageNumber,
        pageSize: this.searchForm.pageSize,
        params: {
          type: this.detailInOutObj.type,
          sentOutSiteId: this.detailInOutObj.sentOutSiteId,
          targetSiteId: this.detailInOutObj.targetSiteId,
          returnStatus: this.detailInOutObj.returnStatus,
          startTime: this.detailInOutObj.startTime,
          endTime: this.detailInOutObj.endTime
        }
      };
      apiGetBagRecycleDetails(data).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    resetForm() {
      this.searchForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumber: ''
        }
      };
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}

.warp >>> .el-form-item {
  margin-bottom: 0 !important;
}
</style>
